module.exports = __webpack_public_path__ + "img/cost-icon__sky_yoga.5b15415f.svg";